import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { format } from 'date-fns';
import ActiveFilterItem from '../../shared/components/ActiveFilterItem';
import DataTable from '../../shared/components/DataTable';
import ActionButton from './components/ActionButton';
import FilterButton from './components/FilterButton';
import useGetHistoricalRecords from './hooks/useGetHistoricalRecords';
import useActiveFiltersStore from './stores/useActiveFiltersStore';
import useIsHistoryFiltersOpenStore from './stores/useIsHistoryFiltersOpenStore';
const translatedFilterKey = {
    customerId: 'Customer ID',
    officeId: 'Office',
    event: 'Event',
    template: 'Template',
    isSent: 'Delivered to SendGrid',
    recipient: 'Recipient',
    sender: 'Sender',
    dateRangeFrom: 'Date range from',
    dateRangeTo: 'Date range to',
};
const HistoryPage = () => {
    const { data, isLoading, mutate, isError, reset } = useGetHistoricalRecords();
    const queryParams = useActiveFiltersStore((store) => store.activeFilters);
    const toggleFilter = useIsHistoryFiltersOpenStore((store) => store.setIsHistoryFiltersOpen);
    const fields = [
        {
            heading: 'Subject',
            key: 'template_name',
        },
        {
            heading: 'Email address',
            key: 'recipient',
        },
        {
            heading: 'Template',
            key: 'template_id',
        },
        {
            heading: 'Clicks',
            key: 'click_events_count',
        },
        {
            heading: 'Status',
            key: 'occurred_events',
            itemShouldRender: (item) => {
                return item.occurred_events.length
                    ? item.occurred_events[item.occurred_events.length - 1]
                    : '';
            },
        },
        {
            heading: 'Date created',
            key: 'delivered_at',
            itemShouldRender: (item) => {
                return item.delivered_at ? format(item.delivered_at, 'MM/dd/yyyy') : '';
            },
        },
        {
            heading: '',
            key: 'action',
            itemShouldRender: (item) => {
                return _jsx(ActionButton, { id: item.id });
            },
        },
    ];
    const handleFilter = () => {
        mutate(undefined, {
            onSettled: () => {
                toggleFilter(false);
            },
        });
    };
    const EmptyState = !data && !isError ? (_jsxs("div", { className: "flex flex-col items-center justify-center py-12", children: [_jsx("h2", { className: "text-xl text-gray-700", children: "Nothing to see? Add some filters" }), _jsx("p", { className: "mt-2 text-sm text-gray-500", children: "Try adding some filters to help with your search." }), _jsx("button", { className: "mt-4 px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:outline-none", onClick: () => toggleFilter(true), children: "Add Filters" })] })) : (_jsx("span", { children: "No data" }));
    const activeFilters = Object.entries(queryParams).reduce((rs, [key, value]) => {
        if (value) {
            rs.push({
                title: translatedFilterKey[key],
                content: ['officeId', 'template'].includes(key) &&
                    typeof value === 'object' &&
                    'label' in value
                    ? value.label
                    : value,
            });
        }
        return rs;
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "w-full flex px-6 pt-4 justify-end gap-3 items-start", children: [_jsx("div", { className: "flex items-center gap-1 flex-wrap float-right justify-end", children: activeFilters.map((item) => (_jsx(ActiveFilterItem, { title: item.title, content: item.content }, item.content + item.title))) }), _jsx(FilterButton, { isLoading: isLoading, onSubmit: handleFilter, onReset: () => reset() })] }), _jsx("div", { className: "px-6 py-4", children: _jsx(DataTable, { fields: fields, data: data?.data, emptyState: EmptyState }) })] }));
};
export default HistoryPage;
